import { lazyNamed } from 'src/utils/lazyNamed.ts';

const Payouts = {
  Statistics: lazyNamed(() => import('./containers/Statistics/index.tsx'), 'Statistics'),
  Documents: lazyNamed(() => import('./containers/Documents/index.tsx'), 'Documents'),
  Layout: lazyNamed(() => import('./components/Layout.tsx'), 'Layout'),
};

export default Payouts;
